import { useState } from 'react';
import { nameHOC } from './hocutils';

export const WithToggle = (WrappedComponent) => {
  const ComponentWithToggle = (props) => {
    const [toggle, setToggle] = useState(false);
    const toggleState = {
      visible: toggle,
      setVisible: (bool) => setToggle(bool),
    };
    return <WrappedComponent {...props} toggleState={toggleState} />;
  };
  ComponentWithToggle.originalName = nameHOC(WrappedComponent);
  ComponentWithToggle.displayName = nameHOC(WrappedComponent, 'WithToggle');
  return ComponentWithToggle;
};
